import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HubFacebookFeedsCommand } from '../commands/hub/event/add.facebook.general.feed.command';
import {
  CategoryChangeData,
  CustomDefaultPlaceCategory,
  HubCalendarActionCommand,
  VisitorSettingsCommand,
} from '../commands/pagination.query.command';
import {
  ExportPdfModalData,
  LogoCommand,
  PDFSettingCommand,
} from '../components/hub/export.pdf.modal/export.pdf.modal.provider';
import { HubCustomBtn } from '../models/hub/hub.custom.btn';
import { EditorChoiceDataSource, HubEvent } from '../models/hub/hub.event';
import { HubPlace } from '../models/hub/hub.place';
import { HubTour } from '../models/hub/hub.tour';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../models/hub/hub.visitor.feature.toggle';
import { HubFeed } from '../models/hub/hub.feed';

@Injectable()
export class HubCalendarStore {
  public actionCommand = new BehaviorSubject(new HubCalendarActionCommand());
}

export class HubFacebookPageFeedsStore {
  public pagesCommand = new BehaviorSubject(new HubFacebookFeedsCommand(null));
}

export class HubFacebookLocationFeedsStore {
  public locationCommand = new BehaviorSubject(new HubFacebookFeedsCommand(null));
}

export class HubCalendarEventsStore {
  public eventsCommand = new BehaviorSubject(Array<HubEvent>());
}

export class HubCalendarPlacesStore {
  public placesCommand = new BehaviorSubject(Array<HubPlace>());
}

export class HubExportPdfStore {
  public expoertPdfCommand = new BehaviorSubject(new ExportPdfModalData());
}

export class HubLogoStore {
  public logoCommand = new BehaviorSubject(new LogoCommand());
}

export class PDFSettingsStore {
  public pdfCommand = new BehaviorSubject(new PDFSettingCommand());
}

export class ToggleStore {
  public toggleCommand = new BehaviorSubject(new HubVisitorFeatureToggle());
}

export class ToggleAndDataSourceStore {
  public toggleAndDataSourceCommand = new BehaviorSubject(new HubVisitorToggleDataSource());
}

export class ToursStore {
  public toursCommand = new BehaviorSubject(Array<HubTour>());
}

export class InfoStore {
  public infoCommand = new BehaviorSubject(String());
}
export class EditorChoiceStore {
  public infoCommand = new BehaviorSubject(new EditorChoiceDataSource());
}

export class CustomBtnStore {
  public customBtnCommand = new BehaviorSubject(new HubCustomBtn());
}

export class CustomDefaultPlaceCategoryStore {
  public CustomDefaultPlaceCategoryCommand = new BehaviorSubject(new CustomDefaultPlaceCategory());
}

export class CustomDefaultPlaceCategoryItemSelectionStore {
  public CustomDefaultPlaceCategoryItemSelectionCommand = new BehaviorSubject(Object());
}

export class CustomDefaultPlaceCategoryItemEditedStore {
  public customDefaultPlaceCategoryItemEditedCommand = new BehaviorSubject(new CategoryChangeData());
}

export class UpdateGeoLocationStore {
  public updateGeoLocationCommand = new BehaviorSubject(new HubFeed());
}
export class BulkAIDescriptionsStore {
  public bulkAIDescriptionsCommand = new BehaviorSubject(String());
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/stores/hub.calendar.store.ts